import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

interface DirectFlightParams {
  directFlight?: true;
}

export function directFlight(criteria: SearchCriteria | PartialSearchCriteria): DirectFlightParams {
  if (criteria.directFlight) {
    return { directFlight: true };
  }
  return {};
}
